<div class="wrapper {{ this.class }}" [style]="boxColor">
  <div class="icon-wrapper">
    <itl-alberta-icon class="{{ this.class }}" [style]="boxColor" [name]="this.icon"></itl-alberta-icon>
  </div>
  <div class="information-text">
    <ng-content></ng-content>
  </div>
</div>
